import React, { useState } from "react";
import { motion } from "framer-motion";

function CreateTemplate() {
  const [fields, setFields] = useState([]);
  const [templateName, setTemplateName] = useState("");

  const addField = () => {
    setFields([...fields, { label: "", placeholder: "" }]);
  };

  const updateField = (index, key, value) => {
    const updated = [...fields];
    updated[index][key] = value;
    setFields(updated);
  };

  const saveTemplate = () => {
    const data = { name: templateName, fields };
    localStorage.setItem(`template-${templateName}`, JSON.stringify(data));
    alert("✅ تم حفظ النموذج بنجاح!");
  };

  return (
    <div className="p-10 bg-gray-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold text-yellow-400 mb-6 text-center">
        ✍️ إنشاء عقد جديد
      </h1>

      <input
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        placeholder="اسم العقد (مثلاً: عقد استشارات)"
        className="p-3 w-full mb-6 rounded bg-gray-800 text-white"
      />

      {fields.map((f, i) => (
        <div key={i} className="mb-4 bg-gray-800 p-4 rounded">
          <input
            placeholder="اسم الحقل (مثلاً: اسم العميل)"
            value={f.label}
            onChange={(e) => updateField(i, "label", e.target.value)}
            className="p-2 w-full mb-2 rounded bg-gray-700 text-white"
          />
          <input
            placeholder="نص مبدئي داخل الحقل"
            value={f.placeholder}
            onChange={(e) => updateField(i, "placeholder", e.target.value)}
            className="p-2 w-full rounded bg-gray-700 text-white"
          />
        </div>
      ))}

      <div className="flex gap-4">
        <motion.button
          onClick={addField}
          whileHover={{ scale: 1.05 }}
          className="bg-green-500 px-6 py-2 rounded text-black font-bold"
        >
          ➕ إضافة حقل جديد
        </motion.button>
        <motion.button
          onClick={saveTemplate}
          whileHover={{ scale: 1.05 }}
          className="bg-yellow-400 px-6 py-2 rounded text-black font-bold"
        >
          💾 حفظ النموذج
        </motion.button>
      </div>
    </div>
  );
}

export default CreateTemplate;
